export const maintanceRoundTemplate = [
  { name: 'description', type: 'title' },
  { name: 'description', type: 'input' },
  { name: 'orderDate', type: 'date' },
  { name: 'made', type: 'date' },
  { name: 'participants', type: 'participants' },
  { name: 'basic', type: 'title' },
  { name: 'distribution', type: 'input' },
  { name: 'conditionChecked', type: 'toggle' },
  { name: 'hopes', type: 'input' },
  { name: 'fixHistory', type: 'input' },
  { name: 'other', type: 'input' },
  { name: 'observations', type: 'textarea' },
  { name: 'proposals', type: 'textarea' },
  { name: 'willOrder', type: 'input' },
  { name: 'addition', type: 'input' },
  { name: 'propertyInformation', type: 'title' },
  { name: 'maintance', type: 'input' },
  { name: 'cleaning', type: 'input' },
  { name: 'buildingType', type: 'input' },
  { name: 'built', type: 'input', inputType: 'number' },
  { name: 'floors', type: 'input', inputType: 'number' },
  { name: 'apartments', type: 'input', inputType: 'number' },
  { name: 'blocks', type: 'input', inputType: 'number' },
  { name: 'buildingMaterial', type: 'input' },
  { name: 'roofType', type: 'input' },
  { name: 'heating', type: 'input' },
  { name: 'pumps', type: 'input' },
  { name: 'heatingCenter', type: 'input' },
  { name: 'smokeExit', type: 'input' },
  { name: 'electricityMain', type: 'input' },
  { name: 'air', type: 'input' },
  { name: 'firePrevention', type: 'input' },
  { name: 'emergencyStop', type: 'input' },
  { name: 'waterOff', type: 'input' },
  { name: 'outdoors', type: 'title' },
  { name: 'waste', type: 'input' },
  { name: 'yard', type: 'input' },
  { name: 'rain', type: 'input' },
  { name: 'yardEquipment', type: 'input' },
  { name: 'outdoorOther', type: 'textarea' },
  { name: 'outdoorImages', type: 'images' },
  { name: 'front', type: 'title' },
  { name: 'seams', type: 'input' },
  { name: 'windows', type: 'input' },
  { name: 'plinths', type: 'input' },
  { name: 'tins', type: 'input' },
  { name: 'feedThroughs', type: 'input' },
  { name: 'frontOther', type: 'input' },
  { name: 'frontImages', type: 'images' },
  { name: 'commonAreas', type: 'title' },
  { name: 'structures', type: 'input' },
  { name: 'saunas', type: 'input' },
  { name: 'waterBlocks', type: 'input' },
  { name: 'lifts', type: 'input' },
  { name: 'civilDefence', type: 'input' },
  { name: 'washRoom', type: 'input' },
  { name: 'commonOther', type: 'textarea' },
  { name: 'commonImages', type: 'images' },
  { name: 'roofing', type: 'title' },
  { name: 'waterExit', type: 'input' },
  { name: 'upperFloor', type: 'input' },
  { name: 'entrance', type: 'input' },
  { name: 'cleaniness', type: 'input' },
  { name: 'safetyEquipment', type: 'input' },
  { name: 'roofingOther', type: 'input' },
  { name: 'roofingImages', type: 'images' },
  { name: 'apartments', type: 'title' },
  { name: 'apartmentItems', type: 'apartments' },
  { name: 'documents', type: 'title' },
  { name: 'maintanceContract', type: 'toggle' },
  { name: 'map', type: 'toggle' },
  { name: 'maintanceHistory', type: 'toggle' },
  { name: 'documentsOther', type: 'input' },
  { name: 'attachment', type: 'title' },
  { name: 'attachment', type: 'textarea' },
];
